import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";

import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-widgets/dist/css/react-widgets.css";
import dates from "react-big-calendar/lib/utils/dates";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import esLocale from "date-fns/locale/es";

import { makeStyles } from "@material-ui/core/styles";

import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import { FormGroup, FormLabel, FormControl, FormCheck } from "react-bootstrap";
import { el } from "date-fns/locale";

const localizer = momentLocalizer(moment); // or globalizeLocalizer

const tipos = [
	{
		value: "Familiar",
		label: "Familiar"
	},
	{
		value: "Adolescentes - Adultos",
		label: "Adolescentes - Adultos"
	},
	{
		value: "Niños",
		label: "Niños"
	},
	{
		value: "Chiquis",
		label: "Chiquis"
	},
	{
		value: "Adolescentes",
		label: "Adolescentes"
	},
	{
		value: "Menores",
		label: "Menores"
	},
	{
		value: "Menores valientes",
		label: "Menores valientes"
	},
	{
		value: "Apta todo público",
		label: "Apta todo público"
	},
	,
	{
		value: "Apta mayores de 16 años",
		label: "Apta mayores de 16 años"
	},
	{
		value: "Adultos",
		label: "Adultos"
	},
	{
		value: "Mayores de 12 años",
		label: "Mayores de 12 años"
	},
	{
		value: "Mayores de 13 años",
		label: "Mayores de 13 años"
	},
	{
		value: "Mayores de 14 años",
		label: "Mayores de 14 años"
	},
	{
		value: "Apta para mayores de 7 años",
		label: "Apta para mayores de 7 años"
	},
	{
		value: "De 5 a 13 años",
		label: "De 5 a 13 años"
	},
	{
		value: "De 8 a 12 años",
		label: "De 8 a 12 años"
	},
	,
	{
		value: "Mayores de 30 años",
		label: "Mayores de 30 años"
	},
	{
		value: "De 5 a 12 años",
		label: "De 5 a 12 años"
	},
	{
		value: "De 14 a 30 años",
		label: "De 14 a 30 años"
	},
	{
		value: "De 13 a 30 años",
		label: "De 13 a 30 años"
	},
	{
		value: "De 13 a 18 años",
		label: "De 13 a 18 años"
	},
	{
		value: "De 5 a 7 años",
		label: "De 5 a 7 años"
	},
	{
		value: "De 8 a 13 años",
		label: "De 8 a 13 años"
	},
	{
		value: "De 12 a 18 años",
		label: "De 12 a 18 años"
	},
	{
		value: "Mayores de 15 años",
		label: "Mayores de 15 años"
	},
	{
		value: "Mayores de 8 años",
		label: "Mayores de 8 años"
	},
	{
		value: "Menores de 7 años",
		label: "Menores de 7 años"
	},
	{
		value: "Menores de 10 años",
		label: "Menores de 10 años"
	},
	{
		value: "Mayores de 18 años",
		label: "Mayores de 18 años"
	},
	{
		value: "De 6 a 13 años",
		label: "De 6 a 13 años"
	},
	{
		value: "De 13 a 30 años",
		label: "De 13 a 30 años"
	},
	{
		value: "De 5 a 8 años",
		label: "De 5 a 8 años"
	},
	{
		value: "De 18 a 30 años",
		label: "De 18 a 30 años"
	}
];

class ActivitiesCalendar extends Component {
	state = {};

	constructor(props) {
		super(props);
		this.state = {
			events: [{}],
			nombre: "",
			descripcion: "",
			fechastartevent: "",
			fechaendevent: "",
			modaltitle: "",
			fetching: false,
			value: "",
			id: "",
			canDelete: false
		};
	}

	componentDidMount() {
		var tempDate = new Date();
		var date =
			tempDate.getFullYear() +
			"-" +
			(tempDate.getMonth() + 1) +
			"-" +
			tempDate.getDate();
		this.setState({ currentDate: date, borrar: false, descripcion: "" });
		this.getActivities(date);
	}

	componentDidUpdate(prevProps, prevState) {}
	handleChange = name => event => {
		this.setState({ ...this.state, [name]: event.target.checked });
	};

	getActivities = date => {
		this.props.loadActivities();
	};

	saveActividad = () => {};

	getActivitiesCallback = () => {
		/* var ares = Object.keys(res).map(function(key) {
        var e = res[key];
        e.start = new Date(res[key].start);
        e.end = new Date(res[key].end);
        if (res[key].available === 0) {
          e.hexColor = "lightgrey";
        } else if (res[key].title == null) {
          e.hexColor = "green";
        }
        e.title = res[key].title;
        e.status = "intialised";
        return e;
      });*/
	};

	handleSelect = ({ start, end }) => {
		var name = "";
		var descripcion = "";
		var tipo = "";

		this.setState({
			nombre: name,
			tipo: tipo,
			descripcion: descripcion,
			fechastartevent: start,
			fechaendevent: end,
			modaltitle: "Crear Actividad",
			show: true,
			borrar: false,
			canDelete: false
		});
	};

	handleClose = () => {
		this.setState({ show: false });
	};

	handleSave = () => {
		let length = this.state.fechastartevent;
		if (length === 0) return;

		if (this.state.borrar === true) {
			let activity = {
				id: this.state.id
			};
			this.props.deleteActivity(activity);
		} else {
			length = this.state.descripcion.length;
			if (length === 0) return;
			var datestring =
				this.state.fechastartevent.getFullYear() +
				"-" +
				(this.state.fechastartevent.getMonth() + 1) +
				"-" +
				this.state.fechastartevent.getDate() +
				" " +
				this.state.fechastartevent.getHours() +
				":" +
				this.state.fechastartevent.getMinutes();

			if (this.state.id === "") {
				let activity = {
					descripcion: this.state.descripcion,
					fecha: datestring,
					tipo: this.state.tipo
				};
				this.props.saveActivities(activity); //.then(res => this.getActivities(this.state.date));
			} else {
				let activity = {
					id: this.state.id,
					descripcion: this.state.descripcion,
					fecha: datestring,
					tipo: this.state.tipo
				};
				this.props.updateActivities(activity);
			}
		}
		this.setState({ show: false });
	};

	handleCreate = () => {
		this.setState({
			show: true,
			modaltitle: "Crear Actividad",
			id: "",
			canDelete: false
		});
	};

	getDate = date => {
		var tdate =
			date.getFullYear() +
			"-" +
			(date.getMonth() + 1) +
			"-" +
			date.getDate() +
			" " +
			date.getHours() +
			":" +
			date.getMinutes();
		return tdate;
	};

	onNavigate = (date, view, action) => {
		console.log("#### onNavigate");
		console.log("#### date=", date);
		console.log("#### view=", view);
		var tdate =
			date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		this.setState({ currentDate: tdate });
		this.getActivities(tdate);
	};

	eventStyleGetter = (event, start, end, isSelected) => {
		//console.log(event);
		var backgroundColor = event.hexColor;
		var style = {
			backgroundColor: backgroundColor,
			border: "1px solid lightgrey"
		};
		return {
			style: style
		};
	};

	showCurrentEvent = event => {
		var id = "";
		var description = "";
		var tipo = "";
		if (event.title !== null) {
			var fields = event.title.split("|");
			id = fields[2];
			tipo = fields[1];
			description = fields[0];

			this.setState({
				modaltitle: "Editar Actividad",
				canDelete: true
			});
		} else {
			this.setState({
				modaltitle: "Crear Actividad",
				canDelete: false
			});
		}
		this.setState({
			id: id,
			descripcion: description,
			tipo: tipo,
			//descripcion: description,
			fechastartevent: event.start,
			fechaendevent: event.end,
			show: true,
			deshabilitar: false
		});
	};

	getNombreState = () => {
		const length = this.state.nombre.length;
		if (length > 0) return "success";
		else return "error";
	};

	getDescripcionState = () => {
		const length = this.state.descripcion.length;
		if (length > 0) return "success";
		else return "error";
	};

	getInicioState = () => {
		const length = this.state.fechastartevent;
		if (length > 0) return "success";
		else return "error";
	};

	getFinState = () => {
		const length = this.state.fechaendevent;
		if (length > 0) return "success";
		else return "error";
	};

	onChangeNombre = (event, { newValue }) => {
		this.setState({
			nombre: newValue
		});
	};

	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Actividades</h2>

				<Modal open={this.state.show}>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "20px",
							margin: "10% auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							<form>
								<h2>{this.state.modaltitle}</h2>

								<TextField
									id="standard-basic"
									label="Descripcion"
									multiline
									rowsMax="4"
									style={{ marginBottom: "20px", width: "100%" }}
									value={this.state.descripcion}
									onChange={e => this.setState({ descripcion: e.target.value })}
								/>
								<br />
								<TextField
									id="standard-select"
									select
									label="Tipo"
									style={{
										marginBottom: "20px",
										width: "100%",
										textAlign: "left"
									}}
									value={this.state.tipo}
									onChange={value =>
										this.setState({ tipo: value.target.value })
									}
								>
									{tipos.map(option => (
										<MenuItem key={option.value} value={option.value}>
											{option.label}
										</MenuItem>
									))}
								</TextField>
								<FormGroup
									controlId="Inicio"
									validationState={this.getInicioState()}
								>
									<MuiPickersUtilsProvider
										utils={DateFnsUtils}
										locale={esLocale}
									>
										<DateTimePicker
											label="Fecha - Hora"
											ampm={false}
											value={this.state.fechastartevent}
											onChange={value =>
												this.setState({ fechastartevent: value })
											}
											style={{ marginBottom: "20px", width: "100%" }}
										/>
									</MuiPickersUtilsProvider>
									<FormControl.Feedback />
								</FormGroup>

								<FormGroup
									controlId="borrar"
									style={
										this.state.canDelete
											? { display: "block" }
											: { display: "none" }
									}
								>
									<FormControlLabel
										control={
											<Checkbox
												checked={this.state.borrar}
												onChange={this.handleChange("borrar")}
												value="borrar"
												disabled={!this.state.canDelete}
											/>
										}
										style={{ marginBottom: "20px" }}
										label="Borrar"
									/>
								</FormGroup>
							</form>

							<Button
								onClick={this.handleSave}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Guardar
							</Button>
							<Button onClick={this.handleClose} color="primary">
								Cerrar
							</Button>
						</div>
					</Paper>
				</Modal>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreate}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Crear Actividad
					</Button>
				</div>
				<div>
					<Calendar
						selectable
						events={this.props.activities}
						localizer={localizer}
						defaultDate={new Date()}
						//defaultView={Calendar.}
						step={60}
						timeslots={1}
						onSelectEvent={event => this.showCurrentEvent(event)}
						onSelectSlot={this.handleSelect}
						startAccessor="start"
						endAccessor="end"
						//views={["day", "week", "agenda"]}
						min={new Date(2018, 10, 0, 0, 0, 0)}
						max={new Date(2030, 10, 0, 23, 59, 0)}
						messages={{
							next: "Siguiente",
							previous: "Atrás",
							today: "Ahora",
							day: "Día",
							week: "Semana"
						}}
						onNavigate={this.onNavigate}
						eventPropGetter={this.eventStyleGetter}
						style={{ height: "100hv", minHeight: "800px" }}
					/>
				</div>
			</React.Fragment>
		);
	}
}

export default ActivitiesCalendar;
